export default "__VITE_ASSET__41457aac__"